import { PALETTE_CHANNELS, PALETTE_VARS, paletteAlpha } from "@styles/palette-vars";

/** Opacity of the tint of the annotation shown in the side panel */
const SELECTED_TINT_OPACITY = 0.12;

/** Class of the calendar event of the annotation shown in the side panel */
export const SELECTED_MARKUP_CLASS = "markup-selected";

/** Tint of the annotation shown in the side panel, wherever it is listed */
export const SELECTED_MARKUP_BACKGROUND = paletteAlpha(PALETTE_CHANNELS.primary.main, SELECTED_TINT_OPACITY);

/** Highlights the table row of the annotation shown in the side panel, with a bar on its left */
export const SELECTED_MARKUP_ROW_SX = {
  backgroundColor: SELECTED_MARKUP_BACKGROUND,
  boxShadow: `inset 3px 0 0 ${PALETTE_VARS.primary.main}`,
  "&:hover": {
    backgroundColor: SELECTED_MARKUP_BACKGROUND
  }
};

/** The element listing the annotation in the current view, if it is rendered */
export function findListedMarkupElement(markupId) {
  // Table rows carry the ID as `data-id`, board cards as `data-markup-id`
  return document.querySelector(`.MuiDataGrid-row[data-id="${markupId}"], [data-markup-id="${markupId}"], .${SELECTED_MARKUP_CLASS}`);
}